import { render, staticRenderFns } from "./SamSidebar.vue?vue&type=template&id=50807e23&scoped=true&"
import script from "./SamSidebar.vue?vue&type=script&lang=js&"
export * from "./SamSidebar.vue?vue&type=script&lang=js&"
import style0 from "./SamSidebar.vue?vue&type=style&index=0&id=50807e23&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50807e23",
  null
  
)

export default component.exports